import React from 'react';

/**
 * Spawnry Logo Component
 * Represents the concept of one story spawning multiple content formats
 * Design: Central node with radiating branches
 */
const Logo = ({ size = 32, color = 'currentColor', showText = false, textColor }) => {
  const iconSize = size;
  const textSize = size * 0.75;

  return (
    <div style={{ display: 'flex', alignItems: 'center', gap: size * 0.25 }}>
      <svg
        width={iconSize}
        height={iconSize}
        viewBox="0 0 48 48"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        {/* Central circle - the "one story" */}
        <circle cx="24" cy="24" r="8" fill={color} />

        {/* Radiating branches - the spawned content */}
        {/* Top branch */}
        <circle cx="24" cy="6" r="4" fill={color} opacity="0.9" />
        <line x1="24" y1="16" x2="24" y2="10" stroke={color} strokeWidth="2.5" strokeLinecap="round" />

        {/* Top-right branch */}
        <circle cx="39.5" cy="11.5" r="4" fill={color} opacity="0.8" />
        <line x1="30" y1="18" x2="36.5" y2="14" stroke={color} strokeWidth="2.5" strokeLinecap="round" />

        {/* Bottom-right branch */}
        <circle cx="42" cy="30" r="4" fill={color} opacity="0.7" />
        <line x1="32" y1="26" x2="38" y2="28.5" stroke={color} strokeWidth="2.5" strokeLinecap="round" />

        {/* Bottom branch */}
        <circle cx="32" cy="42" r="4" fill={color} opacity="0.6" />
        <line x1="28" y1="31" x2="30" y2="38" stroke={color} strokeWidth="2.5" strokeLinecap="round" />

        {/* Left branch */}
        <circle cx="6" cy="20" r="4" fill={color} opacity="0.75" />
        <line x1="16" y1="22" x2="10" y2="20.5" stroke={color} strokeWidth="2.5" strokeLinecap="round" />
      </svg>

      {showText && (
        <span style={{
          fontSize: textSize,
          fontWeight: '700',
          color: textColor || color,
          letterSpacing: '-0.02em'
        }}>
          Spawnry
        </span>
      )}
    </div>
  );
};

export default Logo;
